import { render, staticRenderFns } from "./directive.vue?vue&type=template&id=5f8d90a4&scoped=true"
import script from "./directive.vue?vue&type=script&lang=js"
export * from "./directive.vue?vue&type=script&lang=js"
import style0 from "./directive.vue?vue&type=style&index=0&id=5f8d90a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8d90a4",
  null
  
)

export default component.exports